<template>
   <div>
        <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
        </div>
       <div class="heading text-center">
            <img class="dividerline" src="../../assets/img/sep.png" alt="">
            <h2>Photo Gallery</h2>
            <img class="dividerline" src="../../assets/img/sep.png" alt="">
       </div>
       <span>Click the image to enlarge</span>
       <div class="row">
            <div class="grid-gallery">
                <section class="grid-wrap">
                <ul class="grid">
                    <li v-for="(image, i) in images" :key="i" >
                        <figure><img class="rm-thumb2" :src="image" @click="onClick(i)"/></figure>
                    </li>
                </ul>
                </section>
            </div>
            <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
        </div>
   </div>
</template>

<script>
//import VueGallery from 'vue-gallery';
import VueGallerySlideshow from 'vue-gallery-slideshow'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
  export default {
    name: 'PhotoGallery',
    data () {
      return {
        msg: 'Content of PhotoGallery',
        images:[],
        index: null,
        isLoading: false,
        fullPage: true,
        info: null,
        startindex:1,
        endindex:1

    }
  },
  components: {
      //'gallery': VueGallery,
       VueGallerySlideshow,
       Loading
    },
    methods: {
    onClick(i) {
      this.index = i;
        },
        onCancel() {
              console.log('User cancelled the loader.')
        }
    },
    computed:{
    },
    beforeMount(){
    },
    mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/imagesettings')
      .then(response => {
        this.info = response.data
        this.startindex=this.info[0].startindex
        this.endindex=this.info[0].endindex   
       
        for (var i = this.endindex; i >= this.startindex; i--){
                 //this.images.push(require('../assets/img/photogallery/'+ i +'.jpg'))
                //this.images.push('http://southamptonpuja.org.uk/assets/img/photogallery/'+ i +'.jpg')
                this.images.push(process.env.WEBSITE_URL + 'assets/img/photogallery/'+ i +'.jpg')
            } 
        
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
     .finally(() => this.isLoading = false)
  }
}

</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/GalleryItems/PhotoGallery.vue